// extracted by mini-css-extract-plugin
export default {"icon":"Tooltip-module__icon__nEulx","default":"Tooltip-module__default__JH6N_"};